import React from 'react';
import {MultiScatterCPU} from 'prophesier/dist/wrapper/index-with-deps-react.min.js';

class BubbleSample extends React.Component {
    constructor() {
        super();
    }
    componentDidMount() {
        
    }
    _currentposition(data) {
        console.log(data)
        
    }
    render() {
        const {dataNames} = this.props;
        //const dataObjectParsed = this.props.dataObject ? JSON.parse(this.props.dataObject.replace(/(\r\n|\n|\r|\s)/gm,"")) : []
        let finalObjectFiltered = []
        let finalNameFiltered = []

        this.props.dataObject.forEach((input, index) => {
            if (this.props.positionFilter.indexOf(index) > -1) {
                finalObjectFiltered.push(input)
                finalNameFiltered.push(dataNames[`positionname${index+1}`])
            }
        })

        return (
            <div>
                <h2><strong>Results</strong></h2>
                <MultiScatterCPU data={finalObjectFiltered} names={finalNameFiltered} currentposition={this._currentposition.bind(this)}/>
            </div>
        );
    }
}

export default BubbleSample;

/* let finalObject = [];
        finalObjectFiltered.forEach((ele, index)=>{
            finalObjectFiltered.forEach((ele2, index2)=>{
                if (index2 > index) {
                    
                    let tempArray = []
                    ele.forEach((input, index3)=>{
                        let obj = {}
                        obj["ax"] = input
                        tempArray.push(obj)
                    })
                    ele2.forEach((input, index3)=>{
                        tempArray[index3]["ay"] = input;
                    })
                    finalObject.push(tempArray)
                } 
            })
        })
        console.log(finalObject)

        console.log(finalNameFiltered)
 */



// WEBPACK FOOTER //
// ./src/samples/run/multiscatter.js